import { Component, Inject, OnInit } from '@angular/core';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { InductionQuestionTypesVM, InductionSlides, ModalAddNewQuestions } from '../../setup-induction-question';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  QuestionsTypes: InductionQuestionTypesVM[],
  inductionSlides: InductionSlides[],
  SectionId: number;
  edit: boolean;
  Question: string;
  QuestionTypeId: number;
  SlideSelectionId: number;
  SlideID: number;
  QuestionId: number;
}
@Component({
  selector: 'app-add-induction-question',
  templateUrl: './add-induction-question.component.html',
  styleUrls: ['./add-induction-question.component.css']
})
export class AddInductionQuestionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AddInductionQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }

  Title: string = "";
  QuestionTypeid: number;
  SlideID: number;
  QuestionsTypes: InductionQuestionTypesVM[] = [];
  inductionSlides: InductionSlides[] = [];
  SectionId: number;

  ngOnInit() {
    this.QuestionsTypes = this.data.QuestionsTypes

    if (this.data.inductionSlides.length > 0) {
      if (this.data.SlideSelectionId) {
        this.data.inductionSlides.map(m => {
          if (m.SlideSelectionId == this.data.SlideSelectionId) {
            this.inductionSlides.push(m)
          }
        })
      } else {
        this.inductionSlides = this.data.inductionSlides
      }

    }

    // this.inductionSlides=this.data.inductionSlides
    console.log("this.data", this.data)
    console.log("this.inductionSlides", this.inductionSlides)




    if (this.data.edit == true) {
      this.Title = this.data.Question;
      this.QuestionTypeid = this.data.QuestionTypeId;
      this.SlideID = this.data.SlideID;

      console.log("this.QuestionTypeid", this.QuestionTypeid)
    }


  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  changeQuestionType(ID) {

  }

  changeInductionSlide(ID) {

  }

  onSubmitClick(): void {
    let params = new ModalAddNewQuestions();

    params.Title = this.Title;
    params.SlideId = Number(this.SlideID);
    params.QuestionTypeId = Number(this.QuestionTypeid);
    params.SelectionId = this.data.SectionId;

    if (this.data.edit) {
      params.QestionId = this.data.QuestionId
      this._inductionService.UpdateQuestions(params).subscribe(res => {
        console.log("CreateInductionSelections", res)
        if (res) {
          this.dialogRef.close(true);
        }
        // this.dialogRef.close();

      })
    } else {
      //create new category
      this._inductionService.AddNewQuestions(params).subscribe(res => {
        console.log("CreateInductionSelections", res)
        if (res) {
          this.dialogRef.close(true);
        }
        // this.dialogRef.close();

      })
    }

  }
}
